import { render, staticRenderFns } from "./ExerciseBundleView.vue?vue&type=template&id=1da72e78&scoped=true&"
import script from "./ExerciseBundleView.vue?vue&type=script&lang=ts&"
export * from "./ExerciseBundleView.vue?vue&type=script&lang=ts&"
import style0 from "./ExerciseBundleView.vue?vue&type=style&index=0&id=1da72e78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da72e78",
  null
  
)

export default component.exports